import type { EpisodeManifest, StageCapabilities } from "./stage-api";

export const spokenOutroCooldownMs = 10 * 60 * 1000;

// A capability can be revoked after an immutable edition was published.
// Do not speak an invitation whose action is currently unavailable.
export function studioOutroPlayback(episode: EpisodeManifest, capabilities: StageCapabilities | undefined,
  lastSpokenAt: number | null, now: number) {
  const outro = episode.studioOutro;
  const share = capabilities?.share === true;
  const tip = capabilities?.tip === true;
  const eligible = outro?.version === "studio-outro-v1" &&
    (outro.kind === "share" || outro.kind === "tip") && episode.sources.length > 0;
  const lines = eligible && (outro.kind === "tip" ? tip : share) &&
    (lastSpokenAt === null || now - lastSpokenAt >= spokenOutroCooldownMs) &&
    outro.lines.length > 0 && outro.lines.every(line => !!line.audio && line.durationMs > 0)
    ? outro.lines : [];
  return { visible: eligible && (share || tip), share, tip, lines };
}
